import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LmoOrdersService } from '~lmo/services';
import { LmoCompletedOrdersService } from '~lmo/services/lmo-completed-orders.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-detail-orders',
  styleUrls: ['./lmo-frac-detail-orders.component.scss'],
  templateUrl: './lmo-frac-detail-orders.component.html',
})
export class LmoFracDetailOrdersComponent implements OnInit {
  public pendingCount$: Observable<number>;
  public inProgressCount$: Observable<number>;
  public completedCount$: Observable<number>;
  @HostBinding('class') public className = 'flex-1 overflow-auto';
  constructor(private ordersService: LmoOrdersService, private completedService: LmoCompletedOrdersService) {}

  public ngOnInit() {
    this.pendingCount$ = this.ordersService.pendingOrders$.pipe(map((pending) => (pending ? pending.length : 0)));

    this.inProgressCount$ = this.ordersService.inProgress$.pipe(
      map((inProgress) => (inProgress ? inProgress.length : 0)),
    );

    this.completedCount$ = this.completedService.completedOrders$.pipe(
      map((completed) => (completed ? completed.length : 0)),
    );
  }
}
